const App = require("./app/App");
const User = require("./user/User");
const Make = require("./make/Make");
const Range = require("./utils/Range");
const Car = require("./car/Car");
const CarModel = require("./car/CarModel");
const Consumption = require("./consumption/Consumption");
const Customer = require("./customer/Customer");
const Rental = require("./rental/Rental");
const Address = require("./utils/Address");
const RentOption = require("./rentOption/RentOption");
const Request = require("./request/Request");
const QuantityOption = require("./rentOption/QuantityOption");
const OptionBase = require("./rentOption/OptionBase");
const MultipleChoiceOption = require("./rentOption/MultipleChoiceOption");
const File = require("./file/File");
const PaymentMethod = require("./payment/PaymentMethod");
const DirectDebit = require("./payment/DirectDebit");
const Color = require("./utils/Color");
const Note = require("./utils/Note");
const Order = require("./order/Order");
const Invoice = require("./invoice/Invoice");
const InvoiceItem = require("./invoice/InvoiceItem");

module.exports = {
    Address,
    App,
    Car,
    CarModel,
    Color,
    Consumption,
    Customer,
    Invoice,
    InvoiceItem,
    Make,
    MultipleChoiceOption,
    Note,
    Range,
    Rental,
    RentOption,
    Request,
    OptionBase,
    Order,
    User,
    QuantityOption,
    File,
    PaymentMethod,
    DirectDebit
}